import React from "react";

function SuccessAlert({ message, subtext, options = {} }) {
  const emoji = options.emoji || "✅";

  return (
    <div style={styles.overlay}>
      <div style={styles.box}>
        <div style={styles.emoji}>{emoji}</div>
        <div style={styles.text}>{message}</div>
        {subtext && <div style={styles.subtext}>{subtext}</div>}
      </div>
    </div>
  );
}

const styles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0, 0, 0, 0.3)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 9999,
  },
  box: {
    backgroundColor: "#e6ffed",
    padding: "20px 30px",
    borderRadius: "12px",
    boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
    textAlign: "center",
    maxWidth: "90%",
  },
  emoji: {
    fontSize: "32px",
    marginBottom: "10px",
  },
  text: {
    fontSize: "18px",
    fontWeight: "bold",
    color: "#2e7d32",
  },
  subtext: {
    fontSize: "14px",
    color: "#2e7d32",
    marginTop: "5px",
  },
};

export default SuccessAlert;
